import { adToBs, isValidBSDate } from '../utils/converter';

type BSDate = { year: number; month: number; day: number };

function resolveBSDate(date: Date | string | number | BSDate): BSDate {
  if (date instanceof Date) {
    return adToBs(date);
  }
  if (typeof date === 'number') {
    return adToBs(date);
  }
  if (typeof date === 'string') {
    const parts = date.split(/[-/.]/);
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);
      if (isValidBSDate(year, month, day)) {
        return { year, month, day };
      }
    }
    const adDate = new Date(date);
    if (!isNaN(adDate.getTime())) {
      return adToBs(adDate);
    }
    throw new Error(`Invalid date input: "${date}"`);
  }
  if (typeof date === 'object' && date !== null && 'year' in date && 'month' in date && 'day' in date) {
    if (!isValidBSDate(date.year, date.month, date.day)) {
      throw new Error(`Invalid BS date: ${date.year}-${date.month}-${date.day}`);
    }
    return date;
  }
  throw new Error('Invalid date type');
}

export interface FiscalYearInfo {
  startYear: number;
  endYear: number;
  formatted: string;
}

/**
 * Returns the Nepali Fiscal Year info for a given date.
 * In Nepal, the fiscal year starts on Shrawan 1 (Month 4 of the BS calendar).
 */
export function getFiscalYear(dateInput: Date | string | number | BSDate): FiscalYearInfo {
  const bsDate = resolveBSDate(dateInput);

  let startYear: number;
  let endYear: number;

  if (bsDate.month < 4) {
    startYear = bsDate.year - 1;
    endYear = bsDate.year;
  } else {
    startYear = bsDate.year;
    endYear = bsDate.year + 1;
  }

  return {
    startYear,
    endYear,
    formatted: `${startYear}/${endYear}`
  };
}
